import React from "react";

export default function Logo() {
  return (
    <img
      src="../bassboost_1.gif"
      alt="bass boost logo"
      height="200px"
      width="200px"
    ></img>
  );
}
